import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { SettingsService } from "./settings.service";

@Injectable({ providedIn: 'root' })
export class SettingsTypeResolver {
  constructor(private settingsService: SettingsService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<void> {
    return this.settingsService.initializeSettingTypes();
  }
}
